import { useTranslation } from "react-i18next";

export const Contacts = () => {
  const { t } = useTranslation();

  return (
    <div className="container">
      <h3 className="container-title">
        {t("contacts.title")}
      </h3>

      <div className="container-links">
        <a
          className="button button-link"
          href="https://www.facebook.com/lwymarienburga"
          target="_blank"
          rel="noreferrer"
        >
          {t("contacts.facebook")}
        </a>

        <a
          className="button button-link"
          href="https://docs.google.com/forms/d/e/1FAIpQLSeczo5s3EGm2UJjW_rP04EAlDdzduitSZDMxXz2cMabl081NQ/viewform"
          target="_blank"
          rel="noreferrer"
        >
          {t("contacts.join")}
        </a>

        <a
          className="button button-link"
          href="https://www.facebook.com/bartosz.bruski/"
          target="_blank"
          rel="noreferrer"
        >
          {t("contacts.contact")}
        </a>
      </div>
    </div>
  );
};

export default Contacts;